export { RangeSlider as Slider } from "./RangeSlider";
export type { RangeSliderProps as SliderProps } from "./RangeSlider";
